import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
const { getEntityValue, getEntityPaths } = webui.getActionByName("utils");

const platformIcons = {
    facebook: "tq-icon-facebook",
    linkedin: "tq-icon-linkedin",
    twitter: "tq-icon-twitter",
    mail: "tq-icon-envelope"
};
const dispatch = webui.getDispatchMethod();

class SocialSharingLink extends BaseComponent {
    constructor(props) {
        super(props);
        const location = window.location.href;
        const facebook = `https://www.facebook.com/sharer/sharer.php?u=${location}`;
        const twitter = `https://twitter.com/intent/tweet?text=${location}`;
        const linkedin = `https://www.linkedin.com/shareArticle?mini=true&url=${location}`;
        let pageTitle = "";
        if (this.props.config.platform === "mail") {
            const metaDataPath = dispatch(getEntityPaths(`${this.props.widgetId}::meta`))[0];
            pageTitle = dispatch(getEntityValue(`${metaDataPath}.title`));
        }
        const mail = `mailto:?subject=Unéo – à lire : ${pageTitle}&body=Découvrez cet article sur ${window.location.origin} : ${location}`;
        this.state = {
            facebook,
            twitter,
            linkedin,
            mail
        };
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.dispatchSirenActions(["click", "default"]);
    }

    render() {
        const platform = this.props.config.platform || "facebook";
        const platformLink = this.state[platform];
        return (
            <a
                href={platformLink}
                target={"_blank"}
                rel="noreferrer"
                className="tq-hyperlink"
                onClick={this.onClick}
                aria-label={platform}
            >
                <i className={platformIcons[platform]} />
            </a>
        );
    }
}

export default webui.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions"
    }
})(SocialSharingLink);
